<template>
  <div class="basic">
    <div class="information">
      <div class="title">
        企业信息<span class="button" @click="sumbit"> {{ (isSave)  ? '保存' :'修改' }} </span>
      </div>
      <div class="form">
        <el-form
          :model="form"
          class="demo-form-inline"
          label-width="200px"
          :rules="rules"
        >
          <el-form-item label="企业logo">
            <div class="custom-upload">
              <el-upload
                class="logo-uploader"
                action="#"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="uploadedFiles"
                accept=".jpg, .jpeg, .png,.webp"
              >
                <div class="upload-box">
                  <img v-if="form.logo" class="preview-img" :src="baseUrl + form.logo" />
                  <i v-else class="el-icon-plus icon"></i>
                </div>
              </el-upload>
              <div v-if="isSave && form.logo" class="re-upload-btn button" @click.stop>
                重新上传
              </div>
            </div>
          </el-form-item>
          <el-form-item label="企业名称" prop="qymc">
            <el-input
              v-model="form.qymc"
              style="width: 460px"
              readonly
              disabled
              placeholder="请输入内容"
            ></el-input>
          </el-form-item>
          <el-form-item label="社会统一信用代码" prop="dm">
            <el-input
              v-model="form.dm"
              style="width: 460px"
              readonly
              disabled
              placeholder="请输入内容"
            ></el-input>
          </el-form-item>
          <el-form-item label="法定代表人" prop="fddbr">
            <el-input
              v-model="form.fddbr"
              style="width: 460px"
              readonly
              disabled
              placeholder="请输入内容"
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证号码" prop="idcard">
            <el-input
              v-model="form.idcard"
              style="width: 460px"
              readonly
              disabled
              placeholder="请输入内容"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="connection">
      <div class="title">联系人信息</div>
      <div class="form">
        <el-form
          ref="form"
          :model="form"
          class="demo-form-inline"
          label-width="200px"
          :rules="rules"
        >
          <el-form-item label="联系人" prop="username">
            <el-input
              v-model="form.username"
              style="width: 460px"
              placeholder="请输入内容"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="phone">
            <el-input
              v-model="form.phone"
              style="width: 460px"
              placeholder="请输入内容"
              :disabled="!isSave"
              maxlength="11"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input
              v-model="form.email"
              style="width: 460px"
              placeholder="请输入内容"
              :disabled="!isSave"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="license">
      <div class="title">营业执照</div>
      <div class="text">
        <h1>请上传最新营业执照的原件彩色扫指件</h1>
        <div>图片支持ipg、jpeg、png格式，大小不超过10M</div>
      </div>

      <div class="custom-upload license-upload">
        <el-upload
          class="license-uploader"
          action="#"
          :auto-upload="false"
          :show-file-list="false"
          :on-change="uploadedFiles1"
          accept=".jpg, .jpeg, .png,.webp"
        >
          <div class="upload-box license-box">
            <img v-if="form.yyzz" class="preview-img" :src="baseUrl + form.yyzz" />
            <div v-else class="upload-placeholder">
              <i class="el-icon-plus icon"></i>
              <div class="upload-tip">点击上传营业执照</div>
            </div>
          </div>
        </el-upload>
        <div v-if="isSave && form.yyzz" class="re-upload-btn button" @click.stop>
          重新上传
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getEnterprise, undateEnterprise } from "./viewApi";
import { uploadFiles } from "@/api/index";
import { validateForm ,validateCellPhone } from '@/utils'

export default {
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_API,
      form: {
        yyzz: null,
        qymc: null,
        dm: null,
        fddbr: null,
        logo: null,
        username: null,
        phone: null,
        idcard: null,
        email: null,
      },
      isSave:false,
      rules: {
        phone: [
          {
            required: true,
            message: "请输入联系人手机号",
            trigger: ["blur", "change"],
          },
          {
            pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/,
            message: "请输入正确的联系方式",
            trigger: ["blur", "change"],
          },
        ],
        email: [
          {
            pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/,
            message: "请输入合法的邮箱",
            trigger: ["blur", "change"],
          },
        ],
      },
      fileList: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async sumbit() {

     if(this.isSave ){

        if (!validateForm(this.$refs["form"])) {
          this.$baseMessage("表单信息缺失。", "error");
          return;
        }

        let params = {
          ...this.form,
        };
        let res = await undateEnterprise(params);
        if (res.code == 1000) {
          this.isSave = false;
          this.$baseMessage("修改成功。", "success");
        }
     }else{

      this.isSave = true;

     }

    },
    uploadedFiles(file) {
      let formData = new FormData();
      formData.append("file", file.raw);
      uploadFiles(formData).then((res) => {
        if (res.data) {
          this.form.logo = res.data.url;
        }
      });
    },
    uploadedFiles1(file) {
      let formData = new FormData();
      formData.append("file", file.raw);
      if (file.size / 1024 / 1024 > 10) {
        this.$baseMessage("上传文件大小不能超过 10MB!", "error");
        return;
      }
      uploadFiles(formData).then((res) => {
        if (res.data) {
          this.form.yyzz = res.data.url;
        }
      });
    },

    async getData() {
      let res = await getEnterprise();
      this.form = res.data;
    },
  },
};
</script>

<style lang="scss" scoped>
.basic {
  background: white;
  border-radius: 16px;
  padding: 10px;
  .title {
    border-bottom: 1px solid #ccc;
    line-height: 40px;
    padding: 0 10px;
    font-weight: bold;
    margin-bottom: 20px;
    text-align: left;
    .button {
      float: right;
    }
  }
  .license {
    text-align: center;

    .text {
      padding: 0 10px;
      margin-left: 40px;
      font-size: 14px;
      line-height: 40px;
      text-align: left;

      h1 {
        font-weight: bold;
        font-size: 15px;
      }

      div {
        color: #909399;
      }
    }

    .custom-upload {
      margin-top: 30px;
    }
  }
  .custom-upload {
    position: relative;
    display: inline-block;

    // logo 上传容器
    .logo-uploader {
      ::v-deep .el-upload {
        display: block;
        width: 100px;
        height: 100px;
        border-radius: 8px;
        overflow: hidden;
        border: 1px dashed #d9d9d9;
        transition: all 0.3s;

        &:hover {
          border-color: #1366ec;
        }
      }
    }

    // 营业执照上传容器
    .license-uploader {
      ::v-deep .el-upload {
        display: block;
        width: 400px;
        height: 240px;
        border-radius: 12px;
        overflow: hidden;
        border: 1px dashed #d9d9d9;
        transition: all 0.3s;
        background: #fafafa;

        &:hover {
          border-color: #1366ec;
          background: #f0f7ff;
        }
      }
    }

    .upload-box {
      width: 100px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;

      &.license-box {
        width: 400px;
        height: 240px;
      }
    }

    .upload-placeholder {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 12px;
      color: #8c939d;

      .icon {
        font-size: 40px;
        color: #c0c4cc;
      }

      .upload-tip {
        font-size: 14px;
        color: #909399;
      }
    }

    .icon {
      font-size: 28px;
      color: #8c939d;
    }

    .preview-img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
      border-radius: 8px;
    }

    .re-upload-btn {
      margin-top: 12px;
      text-align: center;
    }
  }

  .buttonList {
    display: block;
    margin-top: 15px;
  }

  .button {
    display: inline-block;
    margin-bottom: 10px;
    border: 1px solid #1366ec;
    padding: 8px 20px;
    border-radius: 6px;
    color: #fff;
    background: #1366ec;
    cursor: pointer;
    line-height: 20px;
    font-size: 14px;
    transition: all 0.3s;

    &:hover {
      background: #007a35;
      border-color: #007a35;
    }
  }
}
</style>